import React from "react";
import Modal from "../Widgets/Modal";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function PreviewModal({ open, handleClose, file_src }) {
    return (
        <Modal
            open={open}
            size={`custom-xxl`}
            CloseModal={handleClose}
            showActiveClass={open}
        >
            <div className="zoom-in-out-img-div">
                <TransformWrapper
                    defaultScale={1}
                    defaultPositionX={1}
                    defaultPositionY={1}
                >
                    <TransformComponent>
                        <img
                            className="cursor-zoom-in"
                            src={file_src}
                            alt="image_preview"
                        />
                    </TransformComponent>
                </TransformWrapper>
            </div>
        </Modal>
    );
}

export default PreviewModal;
